const VideoPrice = {
	// Captures charges by video quantity input
	rule: function (price, quantity) {
		const upsellTotal =
			Number($(".product-price").attr("data-upsell-dvd-total-price")) +
			Number($(".product-price").attr("data-upsell-usb-total-price")) +
			Number($(".product-price").attr("data-upsell-enhanced-content-total-price"))
    ;
		var newPrice = 0;
		newPrice += price * Math.max(1, quantity);
		newPrice += upsellTotal;
		return [newPrice, formatMoney(newPrice)];
	},
	variants: function (callback) {
		var videoQuantityInput = $('input[name="video-quantity"]');
		var submitButton = $("button.product-form__submit");
		var errorMessageWrapper = $(".product-video__error-message-wrapper");
		// default quantity > 1 so enable button
		submitButton.prop("disabled", false);
		videoQuantityInput.change(function (e) {
			var value = Number($(this).val());
			if (value > CONSTANTS.VIDEO.THRESHOLD) {
				$(this).val(CONSTANTS.VIDEO.THRESHOLD);
				value = CONSTANTS.VIDEO.THRESHOLD;
				errorMessageWrapper.removeAttr("hidden");
				errorMessageWrapper
					.find(".product-video__error-message")
					.text(
						`Maximum quantity for video input is ${CONSTANTS.VIDEO.THRESHOLD}`
					);
			} else {
				errorMessageWrapper.attr("hidden", true);
			}
			if (value > 0) {
				if (submitButton.prop("disabled")) {
					submitButton.prop("disabled", false);
				}
			} else {
				submitButton.prop("disabled", true);
			}

			if (callback) {
				callback(value);
			}
		});
	},
};

document.addEventListener("DOMContentLoaded", () => {
	const priceRegularWrapper = $(".product-price .price-item--regular");
	const priceSaleWrapper = $(".product-price .price-item--sale");
	const originalPrice = Number(
		$(".product-price").attr("data-compare-price")
	);
	const originalSalePrice = Number($(".product-price").attr("data-price"));

	VideoPrice.variants((quantity) => {
		const [newPriceRegular, newPriceRegularFormatted] = VideoPrice.rule(
			originalPrice,
			quantity
		);
		const [newPriceSale, newPriceSaleFormatted] = VideoPrice.rule(
			originalSalePrice,
			quantity
		);
		priceRegularWrapper.text(newPriceRegularFormatted);
		priceSaleWrapper.text(newPriceSaleFormatted);
		$(".product-price").attr("data-total-price", newPriceSale);
		$(".product-price").attr("data-total-compare-price", newPriceRegular);
	});
});